const React = require('react');
const withState = require('../../../../../../../../utils/withState');
const {FormWrapper, FormSubmitBtn, FormAdditionalBtn} = require('../../../../../../../dumb/FormHandlers');
const {LimitsCard} = require('../../../../../../../dumb/AdminHelpers/AdminConfigs');

const {CARDS_LIST, INNER_FIELDS} = require('./constants/');
const customerLimitsSchema = require('./utils/customerLimitsSchema');

module.exports = withState((setState, self, onMount) => {
  return (state) => {
    const initialData = CARDS_LIST.reduce((acc, {id}) => {
      acc[id] = {};
      INNER_FIELDS.forEach((name) => acc[id][name] = '0');
      return acc;
    }, {});

    return (
      <div className="mt22">
        <FormWrapper
          data={initialData}
          schema={customerLimitsSchema}
        >
          {(formCtx) => (
            <>
              {CARDS_LIST.map(({id, title}) => (
                <div key={id} className="mt10">
                  <LimitsCard id={id} title={title} formCtx={formCtx} />
                </div>
              ))}
              <div className="mt60 layoutRow fxwWrap mh-27">
                <div className="ph27">
                  <FormSubmitBtn formCtx={formCtx}>
                    Save configuration
                  </FormSubmitBtn>
                </div>
                <div className="ph27">
                  <FormAdditionalBtn>
                    Reset to global
                  </FormAdditionalBtn>
                </div>
                <div className="ph27">
                  <FormAdditionalBtn>
                    Reset to risk limit
                  </FormAdditionalBtn>
                </div>
              </div>
            </>
          )}
        </FormWrapper>
      </div>
    )
  }
})
